import { TextField } from "@material-ui/core";
import type { ReactNode } from "react";

type FieldError = {
  message?: Record<string, unknown>;
};

type TextFieldWithErrorProps = {
  label: string;
  type?: string;
  objectKey: string;
  error: FieldError | undefined;
  editedCable: Record<string, unknown> | undefined;
  setEditedCable: (value: Record<string, unknown>) => void;
  helperText?: ReactNode;
};

const TextFieldWithError = ({
  label,
  type,
  objectKey,
  error,
  editedCable,
  setEditedCable,
  helperText
}: TextFieldWithErrorProps) => {
  return (
    <TextField
      error={error?.message?.[objectKey] !== undefined}
      helperText={error?.message?.[objectKey] ?? helperText}
      label={label}
      margin="normal"
      type={type}
      value={(editedCable ?? {})[objectKey] || ""}
      onChange={(event) => {
        if (type === "custom_number") {
          const isNumber = !Number.isNaN(Number.parseFloat(event.target.value));

          if (event.target.value === "" || isNumber) {
            const nextValue = {
              ...editedCable,
            };
            nextValue[objectKey] =
              event.target.value === ""
                ? ""
                : `${Number.parseFloat(event.target.value)}`;
            setEditedCable(nextValue);
          }
        } else {
          const nextValue = {
            ...editedCable,
          };
          nextValue[objectKey] = event.target.value;
          setEditedCable(nextValue);
        }
      }}
      variant="standard"
      sx={{ flex: "0 0 48%" }}
    />
  );
};

export default TextFieldWithError;
